import React from 'react';
import { WhitePanel } from '../../index';

import { Accordian, Group, Question, Answer, Email, Call } from '../../FAQ';

export default function FAQ() {
  return (
    <WhitePanel >
      <h2 id="#faqs">FAQS</h2>
      <Accordian title="Health and Safety Issues">
        <Group>
          <p>Traveling to the mountains poses some inherent risks. As such, the best strategy is to prepare for the worst and then hope for the best.</p>
          <Question question="PRE-EXISTING CONDITIONS" />
          <Answer>
          The first thing to keep in mind is to see if you have pre-existing conditions that could cause complications at high altitudes. Specifically, suppose you have sickle cell disease, pulmonary hypertension, obesity hypoventilation syndrome, or congenital heart problems. In that case, we highly recommend you consult with a qualified physician before planning a trip to the mountains.<a href="https://honeyguideapps.com/p/health-and-safety-while-trekking-in-nepal#pre-existing-conditions-to-consider-before-trekking-in-nepal"> Read more.</a>
          </Answer>
          <Question question="ALTITUDE-ILLNESS" />
          <Answer>
          Given the low amount of oxygen at high altitudes, a sensible ascent is essential to give your body the time to acclimate to the thin air. Failure to do so can lead to your lungs or brain filling up with water leading to death in some cases. The key is not to climb more than 500 meters in one day once you pass the 2,500 meters mark. <a href="https://honeyguideapps.com/p/health-and-safety-while-trekking-in-nepal#altitude-illness-while-trekking-in-nepal">Read more.</a>
          </Answer>
          <Question question="ENVIRONMENTAL HAZARDS" />
          <Answer>
          Given the extreme weather in the high mountains, proper gear and regimen must have a safe and comfortable tour. The three most important things that you have to prepare for are cold, snow, and radiation. As such, invest in the right sunglasses, sunscreen, boots, and clothing. <a href="https://honeyguideapps.com/p/health-and-safety-while-trekking-in-nepal#environmental-hazards-while-trekking-in-nepal">Read more.</a>
          </Answer>
          <Question question="TRAVEL INSURANCE" />
          <Answer>
          We highly recommend everyone get travel insurance covering high altitude evacuation before leaving on a trek to the high mountains. <a href="https://www.globalrescue.com/common/blog/detail/Mission-Brief-Nepal/">Global Rescue</a> and <a href="https://www.worldnomads.com/travel-insurance/nepal-travel-insurance">World Nomads</a> are both highly recommended.
          For Nepali travelers, please note that insurance that covers helicopter rescue is not available as of now. As such, please be careful while planning your tour and only work with companies that can provide timely evacuation service if needed.
          </Answer>
          <Question question="RESCUE AND EMERGENCY" />
          <Answer>
          As health facilities are limited in the mountains, a helicopter's evacuation is usually the only option during an emergency. As such, the right insurance provider is essential. If you are not buying insurance for some reason, please ensure that there is someone in Kathmandu who can coordinate payments for a helicopter rescue. <a href="">Here are some other contacts</a> that might come in handy during an emergency.
          If you still have questions, please feel free to <Call /> or email Ashish at <Email />
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="Payment Information">
        <Group>
          <Question question="HOW DO I MAKE A PAYMENT?" />
          <Answer>
            To confirm your tour, you will have to make complete payment either through one of your integrated payment gateways or transfer the funds to the following bank accounts:
            <h6>For Nepali citizens:</h6>
            Account Name:: HoneyGuide Pvt. Ltd.
            Beneficiary Bank: Himalayan Bank, Patan Branch
            Account Number: 00606903770018
            <h6>For Indian Citizens:</h6>
            <h6>For USD transfers</h6>
            Account Name: HoneyGuide Apps, Inc.
            Bank Name: Silicon Valley Bank
            Account Number: 3302225311
            Swift Code: SVBKUS6S
            ABA Routing Number: 121140399
          </Answer>
        </Group>
      </Accordian>
      <Accordian title="Booking Changes, Cancellation, and Refunds">
        <Group>
          <Question question="BOOKING A TOUR"/>
          <Answer>
            Deposit Required for Reservation: 50 percent of total tour cost
            Deadline for Full Payment: 2 weeks before the tour begins
          </Answer>

          <Question question="CHANGING A TOUR"/>
          <Answer>
            Two weeks before tour date: No extra charge
            1 to 2 weeks before tour date: 10% additional charge
            Two days to 1 week between tour date: 20% additional charge
            Within two days of tour date: Above 30% (variable)	
          </Answer>
          
          <Question question="CANCELLING A TOUR"/>
          <Answer>
            Two weeks before tour date: No charge (transaction charges may apply)
            One to two weeks before tour date: 20% Cancellation Charge
            Two days to one week between tour date: 50% Cancellation Charge
            Within two days of tour date: No Refund.
          </Answer>

          <Question question="DELAYS AND CHANGES DURING THE TOUR"/>
          <Answer>
            In case of flight delays/cancellations due to bad weather or unforeseen circumstances, HoneyGuide will change the dates at no additional costs. However, any extra cost incurred, including but not limited to accommodation and food, will be the responsibility of the traveler.<br/>
            In case of changes due to the trekker's health issues, HoneyGuide will make all the changes without any additional cost. However, any extra charge because of the changes will be the responsibility of the traveler.
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="Weather">
        <p>While Nepal's mountains see six seasons, the best period to go to the mountains is from March-May and September-December. However, every season has its quirk, just like people. So keep reading to find your match.<br/>
        For those going to Everest Region, do check out the <a href="https://honeyguideapps.com/blog/everest-base-camp-best-time-to-go-seasonal-breakdown">Best time to go to Everest post.</a></p>
        <Group>
          <Question question="January/February (Winter)"/>
          <Answer>
          January/February is a good time for trekkers willing to brave the cold and snow for empty trails, fantastic mountain views, and wildlife sightings.
          </Answer>

          <Question question="March/April (Spring)"/>
          <Answer>
          This is a period that offers a little bit of everything: a little bit of mountain view, a little bit of warm weather, a little bit of flowers, a little bit of crowd, and a whole lot of fun.
          </Answer>

          <Question question="May/June (Summer)"/>
          <Answer>
            This is the best time for those into nature. The flowers are quite something this time of the year, and the bird activity is fantastic. The monsoon hasn't started, and as such, mornings are still clear with beautiful mountain views. 
          </Answer>

          <Question question="July/August (Monsoon)"/>
          <Answer>
          Only for hardcore trekkers who are willing to put up with the elements for an authentic cultural experience and high altitude flowers. Also, flight disruptions are very likely, and chances of mountain views are close to zero.
          </Answer>

          <Question question="September/October (Fall)"/>
          <Answer>
          This period is everyone's darling, and the trails are as crowded as they can be. The mountain views are something to write home about, and the temperature is just perfect.
          </Answer>

          <Question question="November/December (Pre-Winter)"/>
          <Answer>
          Another popular period among trekkers and the driest two months in the calendar. Indeed it has gotten a bit nippy during the mornings and evenings, but it is still manageable. Count on a lot of sunshine and crystal clear mountain views. 
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="What gear should I take?">
        <Group>
        The difficult thing with gear is to make sure you have enough without carrying too much. Whether you are walking or taking the helicopter, the most important thing is to layer up. As such inner thermals, shirts, fleece, a down jacket, and trousers are essential. A warm hat and a buff are beneficial. As for shoes, feel free to make your pick depending on the weather and altitude. Given the amount of UV up there, good sunscreen and sunglasses are also essential.<a href="https://honeyguideapps.com/p/trekking-in-nepal-checklist"> Read more.</a>
        </Group>
      </Accordian>
      </WhitePanel>
  );
}




// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/FAQ.jsx